(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-commission"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('omj-affiliate-commission')) {
  customElements.define('omj-affiliate-commission', class extends HTMLElement {
    connectedCallback() {
      this.raf = requestAnimationFrame(() => this.init());
    }
    init() {
      this.video = this.querySelector('video');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.video) {
        this.video.muted = true;
        this.onMotion = () => {
          if (this.motion.matches) this.video.pause();
          else this.video.play().catch(() => {});
        };
        this.motion.addEventListener('change', this.onMotion);
        if (this.motion.matches) this.video.pause();
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) this.video.pause();
              else if (!this.motion.matches) this.video.play().catch(() => {});
            });
          });
          this.videoObserver.observe(this);
        }
      }
      const number = this.querySelector('[data-counter]');
      if (number) {
        const target = Number(number.dataset.counter);
        const duration = Number(number.dataset.duration) || 1200;
        const animate = () => {
          if (this.countStarted) return;
          this.countStarted = true;
          if (this.motion.matches) { number.textContent = target; return; }
          number.textContent = '0';
          let start;
          const tick = now => {
            if (!this.isConnected) return;
            start ??= now;
            const progress = Math.min((now - start) / duration, 1);
            number.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
            if (progress < 1 && !this.motion.matches) this.countFrame = requestAnimationFrame(tick);
            else number.textContent = target;
          };
          this.countFrame = requestAnimationFrame(tick);
        };
        if ('IntersectionObserver' in window) {
          this.counterObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { animate(); this.counterObserver.disconnect(); }
          }, { threshold: 0.2 });
          this.counterObserver.observe(number);
        } else animate();
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      cancelAnimationFrame(this.countFrame);
      const number = this.querySelector('[data-counter]');
      if (number) number.textContent = number.dataset.counter;
      this.videoObserver?.disconnect();
      this.counterObserver?.disconnect();
      if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-final-cta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('omj-affiliate-final-cta')) {
  customElements.define('omj-affiliate-final-cta', class extends HTMLElement {
    connectedCallback() {
      this.raf = requestAnimationFrame(() => this.init());
    }
    init() {
      this.video = this.querySelector('video');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.video) {
        this.video.muted = true;
        this.onMotion = () => {
          if (this.motion.matches) this.video.pause();
          else this.video.play().catch(() => {});
        };
        this.motion.addEventListener('change', this.onMotion);
        if (this.motion.matches) this.video.pause();
        if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) this.video.pause();
              else if (!this.motion.matches) this.video.play().catch(() => {});
            });
          });
          this.videoObserver.observe(this);
        }
      }
      
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      cancelAnimationFrame(this.countFrame);
      const number = this.querySelector('[data-counter]');
      if (number) number.textContent = number.dataset.counter;
      this.videoObserver?.disconnect();
      this.counterObserver?.disconnect();
      if (this.motion && this.onMotion) this.motion.removeEventListener('change', this.onMotion);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('omj-affiliate-hero')) {
  customElements.define('omj-affiliate-hero', class extends HTMLElement {
    connectedCallback() {
      this.raf = requestAnimationFrame(() => this.init());
    }
    init() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const video = this.video;
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      this.tryPlay = () => {
        if (!this.isConnected || document.hidden || video.error) return;
        if (!video.paused) return;
        if (this.playPending) return;
        this.playPending = true;
        Promise.resolve(video.play()).catch(() => {}).finally(() => { this.playPending = false; });
      };
      video.addEventListener('loadeddata', this.tryPlay, { signal });
      video.addEventListener('canplay', this.tryPlay, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else this.tryPlay();
      }, { signal });
      window.addEventListener('pageshow', this.tryPlay, { signal });
      document.addEventListener('pointerdown', this.tryPlay, { passive: true, signal });
      // Retry when visible; do not pause on the observer's initial offscreen report.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.tryPlay();
        });
        this.observer.observe(video);
      }
      this.tryPlay();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      this.abort?.abort();
      this.observer?.disconnect();
      this.video?.pause();
      this.playPending = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["affiliate-steps"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', (event) => { const step = event.target.closest('.af-step'); if (step && matchMedia('(max-width: 749px)').matches) step.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'}); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-earn"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', event => {
 const card = event.target.closest('.lo-card');
 if (card && matchMedia('(max-width:749px)').matches) card.scrollIntoView({behavior:'auto',block:'nearest',inline:'start'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('omj-loyalty-hero')) {
  customElements.define('omj-loyalty-hero', class extends HTMLElement {
    connectedCallback() {
      this.raf = requestAnimationFrame(() => this.init());
    }
    init() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const video = this.video;
      video.defaultMuted = true;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      this.tryPlay = () => {
        if (!this.isConnected || document.hidden || video.error) return;
        if (!video.paused) return;
        if (this.playPending) return;
        this.playPending = true;
        Promise.resolve(video.play()).catch(() => {}).finally(() => { this.playPending = false; });
      };
      video.addEventListener('loadeddata', this.tryPlay, { signal });
      video.addEventListener('canplay', this.tryPlay, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) video.pause();
        else this.tryPlay();
      }, { signal });
      window.addEventListener('pageshow', this.tryPlay, { signal });
      document.addEventListener('pointerdown', this.tryPlay, { passive: true, signal });
      // Retry when visible; do not pause on the observer's initial offscreen report.
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) this.tryPlay();
        });
        this.observer.observe(video);
      }
      this.tryPlay();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.raf);
      this.abort?.abort();
      this.observer?.disconnect();
      this.video?.pause();
      this.playPending = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty-steps"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', (event) => { const step = event.target.closest('.af-step'); if (step && matchMedia('(max-width: 749px)').matches) step.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'}); });

  } catch(e) { console.error(e); }
})();
})();
